// Encode a single query value using the browser's URLSearchParams rules.
// Spaces remain `+` while delimiters such as `&` and `/` are escaped.
export const encodeQueryValue = (value) => {
  const params = new URLSearchParams();
  params.set("value", value == null ? "" : String(value));
  return params.toString().slice("value=".length);
};
